export default __webpack_public_path__ + "static/india-087fabcdadd3145eff8bfe615077d436.webp";